import React, { useState } from 'react'
import Chatbot from './Chatbot'
import ChatForm from './ChatForm'

function ChatboatMain() {
  const [chatHistory, setChatHistory]=useState([]);
  return (
     <div className='container'>
       <div className='chatbot-popup'>
         {/* Chatboat header */}
       <div className='chat-header'>
       <div className='header-info'>
       <Chatbot/>
       <h2 className='logo-text'>Chatbot</h2>
       </div>
       <button className='material-symbols-rounded'><i class="bi bi-caret-down-fill"></i></button>
       </div>
 {/* Chatboat body */}
       <div className='chat-body'>
       <div className='message bot-message'>
         <Chatbot/>
         <p className='message-text'>
           Hey there <br/> How can I help you today?
         </p>
       </div>
       <div className='message user-message'>
      
         <p className='message-text'>
           hgvghj , vggjhk vhjk
         </p>
       </div>
       {/* Chatboat Footer */}
       <div className='chat-footer'>
         <ChatForm setChatHistory={setChatHistory}/>
       </div>
       </div>
       </div>
     </div>
   )
}

export default ChatboatMain
